export default __webpack_public_path__ + "static/media/nibble.30bfb494.png";